import React from 'react';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import ImageIcon from '@material-ui/icons/Image';
import fileStackClient from '../../../../../config/fileStack/fileStackClient';

function ImagePicker (props) {
    const { config, uploadImage } = props;
    if (!config.fileStack) return null;   // bail and don't display icon if fileStack config failed to load

    const client = fileStackClient(uploadImage, config.fileStack);
    const handleMouseDown = () => client.open();

    // if client fails to load, don't display icon
    return client && (
        <IconButton onMouseDown={handleMouseDown}>
            <ImageIcon />
        </IconButton>
    );
}

const mapStateToProps = state => ({
    config: state.user.profile.configuration,
});

export default connect(mapStateToProps)(ImagePicker);
